import staticData from "./staticData"

export default {
  root: '/',
  editBooking: '/edit_booking/:id',
  newBooking: '/new_booking',
  trade: '/seattrade',
  activateAccount: '/activate',
  basename: staticData.basePath,
}
